import {
  SELECT_INPUT_OTHER_VALUE,
  TEAM_OPTIONS
} from "@/src/common/business-layer/constants"
import { SelectOption, SimpleSelect } from "@/src/common/components/Select"
import Button from "@/src/sb/components/Button"
import { TextInput } from "@/src/sb/components/Input"
import { useEffect, useState } from "react"

import Field from "./Field"
import {
  PROMPT_MENU_CLASS_NAMES,
  PROMPT_MENU_HEIGHT,
  SELECT_CLASS_NAMES,
  SPECIFY_INPUT_CLASSES
} from "./fieldStyles"

export type TeamSelection = {
  team: string
  teamOther: string
}

export const EMPTY_TEAM_SELECTION: TeamSelection = {
  team: "",
  teamOther: ""
}

type TeamStepProps = {
  initialValues?: TeamSelection
  onSubmit: (values: TeamSelection) => void
  onBack: () => void
  onChange?: (values: TeamSelection) => void
}

const TeamStep = ({
  initialValues = EMPTY_TEAM_SELECTION,
  onSubmit,
  onBack,
  onChange
}: TeamStepProps) => {
  const [team, setTeam] = useState(initialValues.team)
  const [teamOther, setTeamOther] = useState(initialValues.teamOther)

  useEffect(() => {
    onChange?.({ team, teamOther })
  }, [team, teamOther])

  const otherSelected = team === SELECT_INPUT_OTHER_VALUE
  const canContinue =
    team.length > 0 && (!otherSelected || teamOther.trim().length > 0)

  return (
    <form
      className="flex flex-col gap-5"
      onSubmit={(e) => {
        e.preventDefault()
        onSubmit({ team, teamOther })
      }}
    >
      <div className="flex flex-col gap-4">
        <Field label="Team" htmlFor="team">
          <SimpleSelect
            inputId="team"
            name="team"
            isSearchable={false}
            placeholder="Select team"
            options={TEAM_OPTIONS}
            menuPlacement="bottom"
            maxMenuHeight={PROMPT_MENU_HEIGHT}
            classNames={{ ...SELECT_CLASS_NAMES, ...PROMPT_MENU_CLASS_NAMES }}
            value={team ? { value: team, label: team } : null}
            onChange={(selectedOption: SelectOption) =>
              setTeam(selectedOption.value)
            }
          />
        </Field>

        {otherSelected ? (
          <Field label="Please specify your team" htmlFor="teamOther">
            <TextInput
              id="teamOther"
              name="teamOther"
              type="text"
              autoFocus
              placeholder="Enter team name"
              value={teamOther}
              extraInputClasses={SPECIFY_INPUT_CLASSES}
              errorShiftCorrected={false}
              onChange={(e) => setTeamOther(e.target.value)}
            />
          </Field>
        ) : null}
      </div>

      <div className="flex items-center justify-end gap-2.5">
        <Button
          type="primary"
          roundness="edge"
          htmlType="button"
          onClick={onBack}
          extraClassNames="dark:bg-[#1A1D21] dark:border-[#4B5563] dark:h-[38px]"
        >
          Back
        </Button>

        <Button
          type="primary"
          roundness="edge"
          htmlType="submit"
          disabled={!canContinue}
          extraClassNames="dark:bg-[#4B5563] dark:h-[38px]"
        >
          Next
        </Button>
      </div>
    </form>
  )
}

export default TeamStep
